<span
  [ngClass]="badgeColorClass"
  class="text-xs font-medium px-2.5 py-0.5 rounded">
  <ng-content></ng-content>
</span>
